// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { AppIcon, useShowAssetProfile } from '@shared/ui-kit/components';

interface AssetItemProps {
  ticker: string;
  deleteItem: (ticker: string) => void;
  assetType: 'etf' | 'mutual_fund';
}

export const AssetItem = ({ ticker, deleteItem, assetType }: AssetItemProps) => {
  const showAssetProfile = useShowAssetProfile();
  const showPopup = ['etf'].includes(assetType);

  return (
    <div className="select-item-box relative" data-testid={'asset-item-' + ticker}>
      <input type="radio" name="benchmark" id={ticker} readOnly />
      <label>
        {ticker}
        {/* {assetType !== 'crypto' && ( */}
        {showPopup && (
          <div
            className="moreinfo ml-2.5"
            data-testid={`popup_${ticker}`}
            onClick={() => showAssetProfile({ ticker, assetType: 'etf' })}
          >
            <AppIcon icon="Info" color="disabled" size="md" />
          </div>
        )}
        {/* )} */}
        <div
          className="moreinfo absolute right-5"
          data-testid={`delete_${ticker}`}
          onClick={() => deleteItem(ticker)}
        >
          <AppIcon icon="Close" />
        </div>
      </label>
    </div>
  );
};
